/* eslint-disable react/prop-types */
import React, { useMemo, useState } from 'react';
import { Redirect, Switch } from 'react-router-dom';
import RouteWithSubRoutes from '../../utils/voucher-route-utils';
import TabNav from '../../nucleus/tabnav/tabnav';
import useVerificationRequired from '../../hooks/useVerificationRequired';
import BottomNav from './BottomNav';
import FinancialBreakdown from './FinancialBreakdown/FinancialBreakdown';
import VoucherComments from './VoucherComments';

const ReviewSend = ({
  location,
  match: {
    params: {
      id, subtab,
    },
  },
  routes,
}) => {
  // The Review page loads the decision's inputs itself; every other page loads them here.
  const { status: verificationStatus, verificationRequired } = useVerificationRequired({ autoLoad: subtab !== 'review' });
  const isVerificationTab = location.pathname.includes('/voucher_verification');
  // Keep the tab while its own page is open and the decision is still loading (no flicker).
  const showVoucherVerification = verificationRequired || (isVerificationTab && verificationStatus === 'loading');

  const [isVoucherValid, setIsVoucherValid] = useState(subtab !== 'send' && JSON.parse(localStorage.getItem('voucher_valid')) === true);
  const tabs = useMemo(() => {
    const baseTabs = [
      {
        link: `/voucher/${id}/review_and_send/future_actions`,
        text: 'Future Actions',
      },
      {
        link: `/voucher/${id}/review_and_send/review`,
        text: 'Review',
      },
    ];

    if (showVoucherVerification) {
      baseTabs.push({
        link: `/voucher/${id}/review_and_send/voucher_verification`,
        text: 'Voucher Verification',
      });
    }

    baseTabs.push({
      link: `/voucher/${id}/review_and_send/send`,
      text: 'Send',
      disabled: !isVoucherValid,
    });

    return baseTabs;
  }, [id, isVoucherValid, showVoucherVerification]);

  const routesWithProps = useMemo(() => routes && routes.map(route => ({
    ...route,
    routeProps: route.path.includes('/review')
      ? { onVoucherValidChange: setIsVoucherValid }
      : route.routeProps,
  })), [routes]);

  return (
    <React.Fragment>
      <div className={`voucher-content`}>
        <TabNav tabs={tabs} selectedTab={location.pathname} />
        {!subtab && <Redirect to={tabs[0].link} />}
        {subtab === 'send' && !isVoucherValid && <Redirect to={`/voucher/${id}/review_and_send/review`} />}
        {isVerificationTab && verificationStatus === 'ready' && !verificationRequired && (
          <Redirect to={`/voucher/${id}/review_and_send/review`} />
        )}
        <Switch>
          {routesWithProps && routesWithProps.map(route => (
            <RouteWithSubRoutes key={route.path} {...route} />
          ))}
        </Switch>
        {!isVerificationTab && <BottomNav location={location.pathname} isVoucherValid={isVoucherValid} />}
      </div>
      {location.pathname !== tabs[0].link &&
        !location.pathname.includes('/voucher_verification') &&
        <div>
          <FinancialBreakdown />
          <VoucherComments />
        </div>
      }
    </React.Fragment>
  );
};


export default ReviewSend;
